import { frontendURL } from '../../../../helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import Ejemplo from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ejemplo'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'ejemplo_index',
          component: Ejemplo,
          meta: {
            permissions: [...ROLES],
          },
        },
      ],
    },
  ],
};
